import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllsubjects } from '../../../../redux/features/croSlice';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useSelector } from 'react-redux';
import GlobalAutoComplete from '../../../../components/GlobalAutoComplete';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import SubjectWiseFreeSlotCard from './SubjectWiseFreeSlotCard';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TUTOR_TP_JSON } from '../utils/tpJson';
import {
  clearAllCities,
  clearAllStates,
  getAllCities,
  getAllCountries,
  getAllStates,
} from '../../../../redux/features/thirdPartySlice';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { getAllClass, getAllSyllabus, getSubjectWiseFreeSlotCards } from '../../../../redux/features/CRDslice';
import dayjs from 'dayjs';
import { genders, RATING } from '../utils/constaints';

export default function SubjectWiseFreeSlot({ setModalState }) {
  const dispatch = useDispatch();
  const allSubject = useSelector((state) => state.cro.allsubjects);
  const allSubjectLoading = useSelector((state) => state.cro.loading);
  const [subject, setSubject] = useState(null);
  const [syllabus, setSyllabus] = useState({ id: -1, value: '' });
  const [fromTimeSlot, setFromTimeSlot] = useState('');
  const [toTimeSlot, setToTimeSlot] = useState('');
  const [gender, setGener] = useState({ id: -1, value: '' });
  const [rating, setRating] = useState({ id: -1, value: '' });
  const [classId, setClassId] = useState({ id: -1, value: '' });
  const [tp, setTp] = useState({ id: -1, value: '' });
  const [country, setCounty] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [sessionRange, setSessionRange] = useState([0, 5000]);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const allCountries = useSelector((state) => state.thirdParty.allCountries.data);
  const allCountriesLoading = useSelector((state) => state.thirdParty.allCountries.loading);
  const allStates = useSelector((state) => state.thirdParty.allStates.data);
  const allStatesLoading = useSelector((state) => state.thirdParty.allStates.loading);
  const allCities = useSelector((state) => state.thirdParty.allCities.data);
  const allCitiesLoading = useSelector((state) => state.thirdParty.allCities.loading);
  const allClass = useSelector((state) => state.crd.allClass);
  const allSyllabus = useSelector((state) => state.crd.allSyllabus);

  const dispatchParams = useMemo(
    () => ({
      fromDate,
      toDate,
      subject_id: subject?.subject_id ?? null,
      syllabus_id: syllabus?.id === -1 ? null : syllabus?.id,
      gender: gender?.id === -1 ? null : gender?.id,
      rating: rating?.id === -1 ? null : rating?.id,
      class_id: classId?.id === -1 ? null : classId?.id,
      session_range: `${sessionRange[0]}-${sessionRange[1]}`,
      from_time: fromTimeSlot || null,
      to_time: toTimeSlot || null,
      city: city?.name || null,
      state: state?.name || null,
    }),
    [fromDate, toDate, subject, syllabus, gender, rating, classId, sessionRange, fromTimeSlot, toTimeSlot, city, state],
  );

  const handleSubmit = () => {
    dispatch(getSubjectWiseFreeSlotCards(dispatchParams));
  };

  useEffect(() => {
    handleSubmit();
    dispatch(getAllsubjects());
    dispatch(getAllCountries());
    dispatch(getAllSyllabus());
    dispatch(getAllClass());
  }, [dispatch]);

  useEffect(() => {
    if (country) dispatch(getAllStates(country?.id));
    else dispatch(clearAllStates());

    setState(null);
  }, [country, dispatch]);

  useEffect(() => {
    if (state) dispatch(getAllCities(state?.id));
    setCity(null);
    dispatch(clearAllCities());
  }, [state, dispatch]);

  return (
    <Paper sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 2 }} elevation={3}>
      <Stack mb={2}>
        <Typography variant="h5" mb={2}>
          Subject-wise Free Slots
        </Typography>
        <Stack justifyContent={'space-between'} direction={{ xs: 'column', sm: 'row' }} gap={2} alignItems={'center'}>
          <Box width={'100%'}>
            <FromAndToDatePicker
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              fullWidth
            />
          </Box>
          <Stack direction={'row'} gap={1} width={'100%'}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                views={['hours', 'minutes']}
                format="HH:mm"
                sx={{ width: '100%' }}
                ampm={false}
                label="From Time"
                onChange={(v) => (v?.isValid() ? setFromTimeSlot(v.format('HH:mm')) : setFromTimeSlot(''))}
              />
              <TimePicker
                views={['hours', 'minutes']}
                format="HH:mm"
                sx={{ width: '100%' }}
                ampm={false}
                label="To Time"
                onChange={(v) => (v?.isValid() ? setToTimeSlot(v.format('HH:mm')) : setToTimeSlot(''))}
              />
            </LocalizationProvider>
          </Stack>
        </Stack>
        <Grid container spacing={2} mt={1}>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalAutoComplete
              sx={{ width: '100%' }}
              selectValue={subject}
              setSelectValue={setSubject}
              data={allSubject}
              loading={allSubjectLoading}
              label="Subject"
              keyName={{
                id: 'subject_id',
                value: 'subject_name',
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={allSyllabus?.length ? [{ syllabus_id: -1, syllabus_name: 'All' }, ...allSyllabus] : []}
              label={'Syllabus'}
              setChange={setSyllabus}
              keys={{ itemId: 'syllabus_id', itemValue: 'syllabus_name' }}
              selectedDetails={syllabus}
              sx={{ width: '100%' }}
            />
          </Grid>
          {/*   <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={[]}
              label={'Timeslots'}
              setChange={setTimeSlot}
              keys={{ itemId: '', itemValue: '' }}
              selectedDetails={timeSlot}
              sx={{ width: '100%' }}
            />
          </Grid> */}
          <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={genders}
              label={'Genders'}
              setChange={setGener}
              keys={{ itemId: 'id', itemValue: 'name' }}
              selectedDetails={gender}
              sx={{ width: '100%', textTransform: 'Capitilize' }}
            />
          </Grid>

          <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={RATING}
              label={'Ratings'}
              setChange={setRating}
              keys={{ itemId: 'id', itemValue: 'name' }}
              selectedDetails={rating}
              sx={{ width: '100%' }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalAutoComplete
              data={allCountries}
              label="Country"
              setSelectValue={setCounty}
              selectValue={country}
              loading={allCountriesLoading}
              keyName={{
                id: 'id',
                value: 'name',
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalAutoComplete
              data={allStates}
              label="State"
              setSelectValue={setState}
              selectValue={state}
              loading={allStatesLoading}
              disabled={!Boolean(allStates?.length)}
              keyName={{
                id: 'id',
                value: 'name',
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalAutoComplete
              data={allCities}
              label="City"
              setSelectValue={setCity}
              selectValue={city}
              disabled={!Boolean(allCities?.length)}
              loading={allCitiesLoading}
              keyName={{
                id: 'id',
                value: 'name',
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={allClass?.length ? [{ class_id: -1, class_name: 'All' }, ...allClass] : []}
              label={'Class'}
              setChange={setClassId}
              keys={{ itemId: 'class_id', itemValue: 'class_name' }}
              selectedDetails={classId}
              sx={{ width: '100%' }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6}>
            <GlobalSelectFieldWithoutFormik
              data={TUTOR_TP_JSON}
              label={'TP'}
              setChange={setTp}
              keys={{ itemId: 'id', itemValue: 'label' }}
              selectedDetails={tp}
              sx={{ width: '100%' }}
            />
          </Grid>
        </Grid>
        <Stack p={2}>
          <Typography variant="subtitle1">Session Range (0-5000+)</Typography>
          <Slider
            max={5000}
            onChange={(_, v) => setSessionRange(v)}
            value={sessionRange}
            color="secondary"
            sx={{ height: 10 }}
            valueLabelDisplay="auto"
          />
          <Typography variant="body2" sx={{ color: 'gray', alignSelf: 'flex-end' }}>
            {`${sessionRange[0]} - ${sessionRange[1]}`}
          </Typography>
        </Stack>
        <Button startIcon={<FilterListIcon />} variant="outlined" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
          Submit
        </Button>
      </Stack>

      <SubjectWiseFreeSlotCard
        setModalState={setModalState}
        fromDate={fromDate}
        toDate={toDate}
        dispatchParams={dispatchParams}
      />
    </Paper>
  );
}
